var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.cloudDialog,
          expression: "cloudDialog"
        }
      ],
      staticClass: "popup",
      attrs: { id: "addCloudPopup" }
    },
    [
      _vm.cloudName == "egnyte"
        ? _c("div", [
            _c(
              "div",
              {
                ref: "addEgnyteCloud",
                staticClass: "content",
                class: [
                  _vm.multipleChoiceArr.includes(_vm.cloudName)
                    ? "amazonS3-content"
                    : "",
                  _vm.specialTipsCloud.includes(_vm.cloudName)
                    ? "threeInput-content"
                    : ""
                ],
                style: {
                  height: _vm.tipShow
                    ? _vm.boxHeight
                    : _vm.getStyleHeight(_vm.cloudName)
                },
                attrs: { id: "addEgnyteCloud" }
              },
              [
                _c("div", { staticClass: "title" }, [
                  _c("span", [
                    _vm._v(" " + _vm._s(_vm.$t("language.common.addCloud")))
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "icon white-close dialog-close",
                    on: {
                      click: function($event) {
                        ;(_vm.cloudDialog = false),
                          (_vm.connect = false),
                          _vm.closeEditCloud()
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "add-egnyteCloud-cont" }, [
                  _c("div", { staticClass: "add-cloud-cont-top" }, [
                    _c("div", { staticClass: "add-cloud-drive-position" }, [
                      _c("div", {
                        staticClass: "cloud add-cloud-size",
                        class: _vm.cloudIcon
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "add-cloud-text" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.$t("language.addCloud." + _vm.cloudName)
                            ) +
                            "\n                        "
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "add-egnyteCloud-cont-body",
                      class: _vm.cloudName == "amazonS3" ? "amazonS3-body" : ""
                    },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.cloudName == "egnyte",
                              expression: "cloudName == 'egnyte'"
                            }
                          ],
                          staticClass: "cloud-cont add-egnyte-des"
                        },
                        [
                          _c("div", { staticClass: "icon-util egnyte-tip " }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "add-egnyteTip",
                            staticStyle: { position: "relative", left: "10Px" },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("language.popup.addCloudPopup.egnyteTip")
                              )
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "cloud-cont" }, [
                        _c("div", { staticClass: "cloud-cont-name" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("language.popup.addCloudPopup.displayName")
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.inputCloudNameValue,
                              expression: "inputCloudNameValue"
                            }
                          ],
                          staticClass: "cloud-cont-input",
                          class:
                            _vm.cloudName == "amazonS3"
                              ? "cloud-amazonS3-input"
                              : "",
                          style: {
                            width: this.$i18n.locale == "italian" ? "450Px" : ""
                          },
                          attrs: {
                            type: "text",
                            placeholder: _vm.$t(
                              "language.addCloud." + _vm.cloudName
                            )
                          },
                          domProps: { value: _vm.inputCloudNameValue },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.inputCloudNameValue = $event.target.value
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.passwordArr.includes(_vm.cloudName),
                              expression: "passwordArr.includes(cloudName)"
                            }
                          ],
                          staticClass: "cloud-cont"
                        },
                        [
                          _c("font", { staticClass: "cloud-cont-name" }, [
                            _vm._v(_vm._s(_vm.$t("language.popup.email")))
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.email,
                                expression: "email"
                              }
                            ],
                            staticClass: "cloud-cont-input",
                            style: {
                              width:
                                this.$i18n.locale == "italian" ? "450Px" : ""
                            },
                            attrs: { type: "text" },
                            domProps: { value: _vm.email },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.email = $event.target.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.passwordArr.includes(_vm.cloudName),
                              expression: "passwordArr.includes(cloudName)"
                            }
                          ],
                          staticClass: "cloud-cont"
                        },
                        [
                          _c("font", { staticClass: "cloud-cont-name" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("language.popup.addCloudPopup.passWord")
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.password,
                                expression: "password"
                              }
                            ],
                            staticClass: "cloud-cont-input",
                            style: {
                              width:
                                this.$i18n.locale == "italian" ? "450Px" : ""
                            },
                            attrs: { type: "password" },
                            domProps: { value: _vm.password },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.password = $event.target.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.cloudName != "iCloudPhotos" ||
                                _vm.cloudName != "iCloudDrive",
                              expression:
                                "cloudName != 'iCloudPhotos' || cloudName != 'iCloudDrive'"
                            }
                          ],
                          staticClass: "add-drive-submit",
                          style: {
                            bottom: _vm.passwordArr.includes(_vm.cloudName)
                              ? -5 + "px"
                              : ""
                          },
                          on: { click: _vm.addDrive }
                        },
                        [
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    !_vm.connect &&
                                    !_vm.localeArr.includes(_vm.$i18n.locale),
                                  expression:
                                    "!connect && !localeArr.includes($i18n.locale)"
                                }
                              ]
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("language.common.add")) +
                                  "  " +
                                  _vm._s(
                                    _vm.$t("language.addCloud." + _vm.cloudName)
                                  )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    !_vm.connect &&
                                    _vm.localeArr.includes(_vm.$i18n.locale),
                                  expression:
                                    "!connect && localeArr.includes($i18n.locale)"
                                }
                              ]
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("language.addCloud." + _vm.cloudName)
                                ) +
                                  "  " +
                                  _vm._s(_vm.$t("language.common.add"))
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.connect,
                                  expression: "connect"
                                }
                              ]
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("language.common.connecting")) +
                                  "\n                            "
                              ),
                              _c("span", { staticClass: "cloudDotting" })
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.cloudName == "egnyte",
                              expression: "cloudName == 'egnyte'"
                            }
                          ],
                          staticClass: "cloud-cont"
                        },
                        [
                          _c("font", { staticClass: "cloud-cont-name" }, [
                            _vm._v(_vm._s(_vm.$t("language.popup.domain")))
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.domain,
                                expression: "domain"
                              }
                            ],
                            staticClass: "cloud-cont-input",
                            style: {
                              width:
                                this.$i18n.locale == "italian" ? "450Px" : ""
                            },
                            attrs: { type: "text" },
                            domProps: { value: _vm.domain },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.domain = $event.target.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.cloudName == "egnyte",
                              expression: "cloudName == 'egnyte'"
                            }
                          ],
                          staticClass: "cloud-cont"
                        },
                        [
                          _c("font", { staticClass: "cloud-cont-name" }, [
                            _vm._v(_vm._s(_vm.$t("language.popup.key")))
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.key,
                                expression: "key"
                              }
                            ],
                            staticClass: "cloud-cont-input",
                            style: {
                              width:
                                this.$i18n.locale == "italian" ? "450Px" : ""
                            },
                            attrs: { type: "text" },
                            domProps: { value: _vm.key },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.key = $event.target.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.cloudName == "egnyte",
                              expression: "cloudName == 'egnyte'"
                            }
                          ],
                          staticClass: "cloud-cont"
                        },
                        [
                          _c("font", { staticClass: "cloud-cont-name" }, [
                            _vm._v(_vm._s(_vm.$t("language.popup.secret")))
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.secret,
                                expression: "secret"
                              }
                            ],
                            staticClass: "cloud-cont-input",
                            style: {
                              width:
                                this.$i18n.locale == "italian" ? "450Px" : ""
                            },
                            attrs: { type: "text" },
                            domProps: { value: _vm.secret },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.secret = $event.target.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.cloudName == "egnyte",
                              expression: "cloudName == 'egnyte'"
                            }
                          ],
                          staticClass: "question-mark addwebdav-icon-position",
                          staticStyle: { positon: "relative" },
                          on: {
                            mouseout: function($event) {
                              _vm.explanShow = false
                            },
                            mouseover: function($event) {
                              _vm.explanShow = true
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "icon-util questions " }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "egnyte-explanation explanation" },
                            [
                              _c("font", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t(
                                      "language.popup.addCloudPopup." +
                                        _vm.cloudName +
                                        "Question"
                                    )
                                  )
                                }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.unTips.includes(_vm.cloudName),
                              expression: "!unTips.includes(cloudName)"
                            }
                          ]
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: { cursor: "pointer" },
                              on: {
                                click: function($event) {
                                  _vm.tipShow = !_vm.tipShow
                                }
                              }
                            },
                            [
                              _c("span", { staticClass: "add-cloud-tips" }, [
                                _vm._v(_vm._s(_vm.$t("language.popup.tips")))
                              ]),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "icon-util folding-panel slide",
                                class: _vm.tipShow
                                  ? "folding-panel-up"
                                  : "folding-panel-down"
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "add-drive-footer" },
                            [
                              _c(
                                "transition",
                                { attrs: { name: "tip-slide" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.tipShow,
                                          expression: "tipShow"
                                        }
                                      ],
                                      ref: "container",
                                      staticClass: "add-cloud-info",
                                      attrs: { id: "container" }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("getStrValue")(
                                              _vm.$t(
                                                "language.popup.addCloudPopup." +
                                                  _vm.cloudName +
                                                  "Tips"
                                              )
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  )
                ])
              ]
            )
          ])
        : _vm.cloudName == "Icedrive"
        ? _c("div", [
            _c(
              "div",
              {
                ref: "addIcedriveCloud",
                staticClass: "content",
                class: [
                  _vm.multipleChoiceArr.includes(_vm.cloudName)
                    ? "amazonS3-content"
                    : "",
                  _vm.specialTipsCloud.includes(_vm.cloudName)
                    ? "threeInput-content"
                    : ""
                ],
                style: {
                  height: _vm.tipShow
                    ? _vm.boxHeight
                    : _vm.getStyleHeight(_vm.cloudName)
                },
                attrs: { id: "addIcedriveCloud" }
              },
              [
                _c("div", { staticClass: "title" }, [
                  _c("span", [
                    _vm._v(" " + _vm._s(_vm.$t("language.common.addCloud")))
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "icon white-close dialog-close",
                    on: {
                      click: function($event) {
                        ;(_vm.cloudDialog = false),
                          (_vm.connect = false),
                          _vm.closeEditCloud()
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "add-icedrive-cont" }, [
                  _c("div", { staticClass: "add-cloud-cont-top" }, [
                    _c("div", { staticClass: "add-cloud-drive-position" }, [
                      _c("div", {
                        staticClass: "cloud add-cloud-size",
                        class: _vm.cloudIcon
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "add-cloud-text" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.$t("language.addCloud." + _vm.cloudName)
                            ) +
                            "\n                        "
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "add-icedrive-cont-body",
                      class: _vm.cloudName == "amazonS3" ? "amazonS3-body" : ""
                    },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.cloudName == "Icedrive",
                              expression: "cloudName == 'Icedrive'"
                            }
                          ],
                          staticClass: "cloud-cont add-icedrive-des"
                        },
                        [
                          _c("div", { staticClass: "icon-util icedrive-tip " }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "add-icedriveTip",
                              staticStyle: {
                                position: "relative",
                                left: "10Px"
                              }
                            },
                            [
                              _c("span", {
                                staticClass: "text-line",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t(
                                      "language.popup.addCloudPopup.icedriveTip"
                                    )
                                  )
                                }
                              }),
                              _c("br"),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "text-line",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t(
                                      "language.popup.addCloudPopup.icedriveTip1"
                                    )
                                  )
                                }
                              }),
                              _c("br"),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "text-line",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t(
                                      "language.popup.addCloudPopup.icedriveTip2"
                                    )
                                  )
                                }
                              })
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "cloud-cont" }, [
                        _c("div", { staticClass: "cloud-cont-name" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("language.popup.addCloudPopup.displayName")
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.inputCloudNameValue,
                              expression: "inputCloudNameValue"
                            }
                          ],
                          staticClass: "cloud-cont-input",
                          class:
                            _vm.cloudName == "amazonS3"
                              ? "cloud-amazonS3-input"
                              : "",
                          style: {
                            width: this.$i18n.locale == "italian" ? "450Px" : ""
                          },
                          attrs: {
                            type: "text",
                            placeholder: _vm.$t(
                              "language.addCloud." + _vm.cloudName
                            )
                          },
                          domProps: { value: _vm.inputCloudNameValue },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.inputCloudNameValue = $event.target.value
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.threeInput.includes(_vm.cloudName),
                              expression: "threeInput.includes(cloudName)"
                            }
                          ]
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "cloud-cont" },
                            [
                              _c("font", { staticClass: "cloud-cont-name" }, [
                                _vm._v(_vm._s(_vm.$t("language.popup.email")))
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.email,
                                    expression: "email"
                                  }
                                ],
                                staticClass: "cloud-cont-input",
                                style: {
                                  width:
                                    this.$i18n.locale == "italian"
                                      ? "450Px"
                                      : ""
                                },
                                attrs: { type: "text" },
                                domProps: { value: _vm.email },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.email = $event.target.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "cloud-cont" },
                            [
                              _c("font", { staticClass: "cloud-cont-name" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.addCloudPopup.passWord"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.password,
                                    expression: "password"
                                  }
                                ],
                                staticClass: "cloud-cont-input",
                                style: {
                                  width:
                                    this.$i18n.locale == "italian"
                                      ? "450Px"
                                      : ""
                                },
                                attrs: { type: "password" },
                                domProps: { value: _vm.password },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.password = $event.target.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.cloudName != "iCloudPhotos" ||
                                _vm.cloudName != "iCloudDrive",
                              expression:
                                "cloudName != 'iCloudPhotos' || cloudName != 'iCloudDrive'"
                            }
                          ],
                          staticClass: "add-drive-submit",
                          style: {
                            bottom: _vm.passwordArr.includes(_vm.cloudName)
                              ? -5 + "px"
                              : ""
                          },
                          on: { click: _vm.addDrive }
                        },
                        [
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    !_vm.connect &&
                                    !_vm.localeArr.includes(_vm.$i18n.locale),
                                  expression:
                                    "!connect && !localeArr.includes($i18n.locale)"
                                }
                              ]
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("language.common.add")) +
                                  "  " +
                                  _vm._s(
                                    _vm.$t("language.addCloud." + _vm.cloudName)
                                  )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    !_vm.connect &&
                                    _vm.localeArr.includes(_vm.$i18n.locale),
                                  expression:
                                    "!connect && localeArr.includes($i18n.locale)"
                                }
                              ]
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("language.addCloud." + _vm.cloudName)
                                ) +
                                  "  " +
                                  _vm._s(_vm.$t("language.common.add"))
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.connect,
                                  expression: "connect"
                                }
                              ]
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("language.common.connecting")) +
                                  "\n                            "
                              ),
                              _c("span", { staticClass: "cloudDotting" })
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ])
              ]
            )
          ])
        : _c("div", [
            !_vm.isTempClose
              ? _c(
                  "div",
                  {
                    ref: "addCloud",
                    staticClass: "content",
                    class: [
                      _vm.multipleChoiceArr.includes(_vm.cloudName)
                        ? "amazonS3-content"
                        : "",
                      _vm.specialTipsCloud.includes(_vm.cloudName)
                        ? "threeInput-content"
                        : ""
                    ],
                    style: {
                      height: _vm.tipShow
                        ? _vm.boxHeight
                        : _vm.getStyleHeight(_vm.cloudName)
                    },
                    attrs: { id: "addCloud" }
                  },
                  [
                    _c("div", { staticClass: "title" }, [
                      _c("span", [
                        _vm._v(" " + _vm._s(_vm.$t("language.common.addCloud")))
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "icon white-close dialog-close",
                        on: {
                          click: function($event) {
                            ;(_vm.cloudDialog = false),
                              (_vm.connect = false),
                              _vm.closeEditCloud()
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "add-cloud-cont" }, [
                      _c("div", { staticClass: "add-cloud-cont-top" }, [
                        _c("div", { staticClass: "add-cloud-drive-position" }, [
                          _c("div", {
                            staticClass: "cloud add-cloud-size",
                            class: _vm.cloudIcon
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "add-cloud-text" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.$t("language.addCloud." + _vm.cloudName)
                                ) +
                                "\n                        "
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "add-cloud-cont-body",
                          class:
                            _vm.cloudName == "amazonS3" ? "amazonS3-body" : ""
                        },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.cloudName == "fourShared",
                                  expression: "cloudName == 'fourShared'"
                                }
                              ],
                              staticClass: "cloud-cont add-4shared-des"
                            },
                            [
                              _c("div", {
                                staticClass: "icon-util egnyte-tip "
                              }),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "add-egnyteTip",
                                staticStyle: {
                                  position: "relative",
                                  left: "10Px"
                                },
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t(
                                      "language.popup.addCloudPopup.fourShared"
                                    )
                                  )
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.cloudName == "iCloudPhotos",
                                  expression: "cloudName == 'iCloudPhotos'"
                                }
                              ],
                              staticClass: "add-iCloudPhotos-des"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "add-iCloudPhotosTip",
                                  staticStyle: {
                                    position: "relative",
                                    left: "10Px"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$t(
                                          "language.popup.addCloudPopup.iCloudPhotosTip"
                                        )
                                      ) +
                                      "\n                            "
                                  ),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.$t(
                                            "language.popup.addCloudPopup.iCloudPhotosTip1"
                                          )
                                        ) +
                                        "\n                                "
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "question-mark",
                                        staticStyle: {
                                          positon: "relative",
                                          display: "inline-block",
                                          "vertical-align": "middle"
                                        },
                                        on: {
                                          mouseout: function($event) {
                                            _vm.explanShow = false
                                          },
                                          mouseover: function($event) {
                                            _vm.explanShow = true
                                          }
                                        }
                                      },
                                      [
                                        _c("div", {
                                          staticClass: "icon-util question-mark"
                                        }),
                                        _vm._v(" "),
                                        _vm.explanShow
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "iCloudPhotos-explanation explanation"
                                              },
                                              [
                                                _c("font", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.$t(
                                                        "language.popup.addCloudPopup.iCloudPhotosTip1Q"
                                                      )
                                                    )
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.$t(
                                            "language.popup.addCloudPopup.iCloudPhotosTip2"
                                          )
                                        ) +
                                        "\n                            "
                                    )
                                  ])
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "cloud-cont" }, [
                            _c("div", { staticClass: "cloud-cont-name" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "language.popup.addCloudPopup.displayName"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.inputCloudNameValue,
                                  expression: "inputCloudNameValue"
                                }
                              ],
                              staticClass: "cloud-cont-input",
                              class:
                                _vm.cloudName === "amazonS3" ||
                                _vm.cloudName === "iDrivee2"
                                  ? "cloud-amazonS3-input"
                                  : "",
                              style: {
                                width:
                                  this.$i18n.locale == "italian" ||
                                  (this.$i18n.locale == "nederlands" &&
                                    _vm.cloudName === "wasabi")
                                    ? "450Px"
                                    : ""
                              },
                              attrs: {
                                type: "text",
                                placeholder: _vm.$t(
                                  "language.addCloud." + _vm.cloudName
                                )
                              },
                              domProps: { value: _vm.inputCloudNameValue },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.inputCloudNameValue = $event.target.value
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.serveCloudArr.includes(
                                    _vm.cloudName
                                  ),
                                  expression:
                                    "serveCloudArr.includes(cloudName)"
                                }
                              ]
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "cloud-cont" },
                                [
                                  _c(
                                    "font",
                                    { staticClass: "cloud-cont-name" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "language.popup.addCloudPopup.server"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.cloudName == "mySQL"
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.serverNumber,
                                            expression: "serverNumber"
                                          }
                                        ],
                                        staticClass: "ftp-cont-right-one",
                                        attrs: { type: "text" },
                                        domProps: { value: _vm.serverNumber },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.serverNumber =
                                              $event.target.value
                                          }
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.cloudName != "mySQL"
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.portNumber,
                                            expression: "portNumber"
                                          }
                                        ],
                                        staticClass: "ftp-cont-right-one",
                                        attrs: { type: "text" },
                                        domProps: { value: _vm.portNumber },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.portNumber = $event.target.value
                                          }
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.cloudName == "webDav"
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.webDavserverHttp,
                                            expression: "webDavserverHttp"
                                          }
                                        ],
                                        staticClass: "ftp-cont-input",
                                        style: {
                                          width:
                                            this.$i18n.locale == "italian"
                                              ? "260Px"
                                              : "280Px"
                                        },
                                        attrs: { type: "text" },
                                        domProps: {
                                          value: _vm.webDavserverHttp
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.webDavserverHttp =
                                              $event.target.value
                                          }
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.cloudName != "webDav"
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.otherServerHttp,
                                            expression: "otherServerHttp"
                                          }
                                        ],
                                        staticClass: "ftp-cont-input",
                                        style: {
                                          width:
                                            this.$i18n.locale == "italian"
                                              ? "260Px"
                                              : "280Px"
                                        },
                                        attrs: { type: "text" },
                                        domProps: {
                                          value: _vm.otherServerHttp
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.otherServerHttp =
                                              $event.target.value
                                          }
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "question-mark",
                                  attrs: { id: "cloudQuestionMark" },
                                  on: {
                                    mouseleave: function($event) {
                                      _vm.explanShow = false
                                    },
                                    mouseover: function($event) {
                                      _vm.explanShow = true
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "icon-util question three-icon-position"
                                    },
                                    [
                                      _vm.explanShow
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "webdav-explanation explanation"
                                            },
                                            [
                                              _c("font", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.$t(
                                                      "language.popup.addCloudPopup." +
                                                        _vm.cloudName +
                                                        "Question"
                                                    )
                                                  )
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "cloud-cont" },
                                [
                                  _c(
                                    "font",
                                    { staticClass: "cloud-cont-name" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "language.popup.addCloudPopup.userName"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.username,
                                        expression: "username"
                                      }
                                    ],
                                    staticClass: "cloud-cont-input",
                                    style: {
                                      width:
                                        this.$i18n.locale == "italian"
                                          ? "450Px"
                                          : ""
                                    },
                                    attrs: { type: "text" },
                                    domProps: { value: _vm.username },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.username = $event.target.value
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "cloud-cont" },
                                [
                                  _c(
                                    "font",
                                    { staticClass: "cloud-cont-name" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "language.popup.addCloudPopup.passWord"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.password,
                                        expression: "password"
                                      }
                                    ],
                                    staticClass: "cloud-cont-input",
                                    style: {
                                      width:
                                        this.$i18n.locale == "italian"
                                          ? "450Px"
                                          : ""
                                    },
                                    attrs: { type: "password" },
                                    domProps: { value: _vm.password },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.password = $event.target.value
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.passwordArr.includes(
                                    _vm.cloudName
                                  ),
                                  expression: "passwordArr.includes(cloudName)"
                                }
                              ],
                              staticClass: "cloud-cont"
                            },
                            [
                              _c("font", { staticClass: "cloud-cont-name" }, [
                                _vm._v(_vm._s(_vm.$t("language.popup.email")))
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.email,
                                    expression: "email"
                                  }
                                ],
                                staticClass: "cloud-cont-input",
                                style: {
                                  width:
                                    this.$i18n.locale == "italian"
                                      ? "450Px"
                                      : ""
                                },
                                attrs: { type: "text" },
                                domProps: { value: _vm.email },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.email = $event.target.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.passwordArr.includes(
                                    _vm.cloudName
                                  ),
                                  expression: "passwordArr.includes(cloudName)"
                                }
                              ],
                              staticClass: "cloud-cont"
                            },
                            [
                              _c("font", { staticClass: "cloud-cont-name" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.addCloudPopup.passWord"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.password,
                                    expression: "password"
                                  }
                                ],
                                staticClass: "cloud-cont-input",
                                style: {
                                  width:
                                    this.$i18n.locale == "italian"
                                      ? "450Px"
                                      : ""
                                },
                                attrs: { type: "password" },
                                domProps: { value: _vm.password },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.password = $event.target.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.cloudName == "iDrivee2",
                                  expression: "cloudName == 'iDrivee2'"
                                }
                              ],
                              staticClass: "cloud-cont"
                            },
                            [
                              _c("font", { staticClass: "cloud-cont-name" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.addCloudPopup.endpoint"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.endPoint,
                                    expression: "endPoint"
                                  }
                                ],
                                staticClass: "cloud-cont-input",
                                class:
                                  _vm.cloudName == "iDrivee2"
                                    ? "cloud-amazonS3-input"
                                    : "",
                                style: {
                                  width:
                                    this.$i18n.locale == "italian"
                                      ? "450Px"
                                      : ""
                                },
                                attrs: { type: "text" },
                                domProps: { value: _vm.endPoint },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.endPoint = $event.target.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.cloudName == "iDrivee2",
                                  expression: "cloudName == 'iDrivee2'"
                                }
                              ],
                              staticClass: "cloud-cont"
                            },
                            [
                              _c("font", { staticClass: "cloud-cont-name" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.addCloudPopup.idriveKeyId"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.accessKey,
                                    expression: "accessKey"
                                  }
                                ],
                                staticClass: "cloud-cont-input",
                                class:
                                  _vm.cloudName == "iDrivee2"
                                    ? "cloud-amazonS3-input"
                                    : "",
                                style: {
                                  width:
                                    this.$i18n.locale == "italian"
                                      ? "450Px"
                                      : ""
                                },
                                attrs: { type: "text" },
                                domProps: { value: _vm.accessKey },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.accessKey = $event.target.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.cloudName == "iDrivee2",
                                  expression: "cloudName == 'iDrivee2'"
                                }
                              ],
                              staticClass: "cloud-cont"
                            },
                            [
                              _c("font", { staticClass: "cloud-cont-name" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.addCloudPopup.idriveSecretAccessKey"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.secretAccessPassword,
                                    expression: "secretAccessPassword"
                                  }
                                ],
                                staticClass: "cloud-cont-input",
                                class:
                                  _vm.cloudName == "iDrivee2"
                                    ? "cloud-amazonS3-input"
                                    : "",
                                style: {
                                  width:
                                    this.$i18n.locale == "italian"
                                      ? "450Px"
                                      : ""
                                },
                                attrs: { type: "passWord" },
                                domProps: { value: _vm.secretAccessPassword },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.secretAccessPassword =
                                      $event.target.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.cloudName == "amazonS3",
                                  expression: "cloudName == 'amazonS3'"
                                }
                              ],
                              staticClass: "cloud-cont"
                            },
                            [
                              _c("font", { staticClass: "cloud-cont-name" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.addCloudPopup.bucketName"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.bucketName,
                                    expression: "bucketName"
                                  }
                                ],
                                staticClass: "cloud-cont-input",
                                class:
                                  _vm.cloudName == "amazonS3"
                                    ? "cloud-amazonS3-input"
                                    : "",
                                style: {
                                  width:
                                    this.$i18n.locale == "italian"
                                      ? "450Px"
                                      : ""
                                },
                                attrs: { type: "text" },
                                domProps: { value: _vm.bucketName },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.bucketName = $event.target.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.cloudName == "amazonS3",
                                  expression: "cloudName == 'amazonS3'"
                                }
                              ],
                              staticClass: "cloud-cont"
                            },
                            [
                              _c("font", { staticClass: "cloud-cont-name" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.addCloudPopup.accessKeyId"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.accessKey,
                                    expression: "accessKey"
                                  }
                                ],
                                staticClass: "cloud-cont-input",
                                class:
                                  _vm.cloudName == "amazonS3"
                                    ? "cloud-amazonS3-input"
                                    : "",
                                style: {
                                  width:
                                    this.$i18n.locale == "italian"
                                      ? "450Px"
                                      : ""
                                },
                                attrs: { type: "text" },
                                domProps: { value: _vm.accessKey },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.accessKey = $event.target.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.cloudName == "amazonS3",
                                  expression: "cloudName == 'amazonS3'"
                                }
                              ],
                              staticClass: "question-mark ",
                              attrs: { id: "cloudQuestionMark" }
                            },
                            [
                              _c("div", {
                                staticClass:
                                  "icon-util question three-icon-position ",
                                attrs: { id: "mark" }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "amazon-explanation mark-all" },
                                [
                                  _c("font", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$t(
                                          "language.popup.addCloudPopup.amazonQuestion"
                                        )
                                      )
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.cloudName == "amazonS3",
                                  expression: "cloudName == 'amazonS3'"
                                }
                              ],
                              staticClass: "cloud-cont"
                            },
                            [
                              _c("font", { staticClass: "cloud-cont-name" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.addCloudPopup.secretAccessKey"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.secretAccessPassword,
                                    expression: "secretAccessPassword"
                                  }
                                ],
                                staticClass: "cloud-cont-input",
                                class:
                                  _vm.cloudName == "amazonS3"
                                    ? "cloud-amazonS3-input"
                                    : "",
                                style: {
                                  width:
                                    this.$i18n.locale == "italian"
                                      ? "450Px"
                                      : ""
                                },
                                attrs: { type: "passWord" },
                                domProps: { value: _vm.secretAccessPassword },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.secretAccessPassword =
                                      $event.target.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.cloudName == "amazonS3",
                                  expression: "cloudName == 'amazonS3'"
                                }
                              ],
                              staticClass: "cloud-cont"
                            },
                            [
                              _c("font", { staticClass: "cloud-cont-name" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.addCloudPopup.endpointOptional"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.endPoint,
                                    expression: "endPoint"
                                  }
                                ],
                                staticClass: "cloud-cont-input",
                                class:
                                  _vm.cloudName == "amazonS3"
                                    ? "cloud-amazonS3-input"
                                    : "",
                                style: {
                                  width:
                                    this.$i18n.locale == "italian"
                                      ? "450Px"
                                      : ""
                                },
                                attrs: { type: "text" },
                                domProps: { value: _vm.endPoint },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.endPoint = $event.target.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.cloudName != "iCloudPhotos" &&
                                    _vm.cloudName != "iCloudDrive",
                                  expression:
                                    "cloudName != 'iCloudPhotos' && cloudName != 'iCloudDrive'"
                                }
                              ],
                              staticClass: "add-drive-submit",
                              style: {
                                bottom: _vm.passwordArr.includes(_vm.cloudName)
                                  ? -5 + "px"
                                  : ""
                              },
                              on: { click: _vm.addDrive }
                            },
                            [
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        !_vm.connect &&
                                        !_vm.localeArr.includes(
                                          _vm.$i18n.locale
                                        ),
                                      expression:
                                        "!connect && !localeArr.includes($i18n.locale)"
                                    }
                                  ]
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("language.common.add")) +
                                      "  " +
                                      _vm._s(
                                        _vm.$t(
                                          "language.addCloud." + _vm.cloudName
                                        )
                                      )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        !_vm.connect &&
                                        _vm.localeArr.includes(
                                          _vm.$i18n.locale
                                        ),
                                      expression:
                                        "!connect && localeArr.includes($i18n.locale)"
                                    }
                                  ]
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "language.addCloud." + _vm.cloudName
                                      )
                                    ) +
                                      "  " +
                                      _vm._s(_vm.$t("language.common.add"))
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.connect,
                                      expression: "connect"
                                    }
                                  ]
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("language.common.connecting")
                                    ) + "\n                            "
                                  ),
                                  _c("span", { staticClass: "cloudDotting" })
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.threeInput.includes(_vm.cloudName),
                                  expression: "threeInput.includes(cloudName)"
                                }
                              ]
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "cloud-cont" },
                                [
                                  _c(
                                    "font",
                                    { staticClass: "cloud-cont-name" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("language.popup.email"))
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.email,
                                        expression: "email"
                                      }
                                    ],
                                    staticClass: "cloud-cont-input",
                                    style: {
                                      width:
                                        this.$i18n.locale == "italian"
                                          ? "450Px"
                                          : ""
                                    },
                                    attrs: { type: "text" },
                                    domProps: { value: _vm.email },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.email = $event.target.value
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "cloud-cont" },
                                [
                                  _c(
                                    "font",
                                    { staticClass: "cloud-cont-name" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "language.popup.addCloudPopup.passWord"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.password,
                                        expression: "password"
                                      }
                                    ],
                                    staticClass: "cloud-cont-input",
                                    style: {
                                      width:
                                        this.$i18n.locale == "italian"
                                          ? "450Px"
                                          : ""
                                    },
                                    attrs: { type: "password" },
                                    domProps: { value: _vm.password },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.password = $event.target.value
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.userNameInput.includes(
                                    _vm.cloudName
                                  ),
                                  expression:
                                    "userNameInput.includes(cloudName)"
                                }
                              ]
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "cloud-cont" },
                                [
                                  _c(
                                    "font",
                                    { staticClass: "cloud-cont-name" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "language.popup.addCloudPopup.userName"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.username,
                                        expression: "username"
                                      }
                                    ],
                                    staticClass: "cloud-cont-input",
                                    style: {
                                      width:
                                        this.$i18n.locale == "italian"
                                          ? "450Px"
                                          : ""
                                    },
                                    attrs: { type: "text" },
                                    domProps: { value: _vm.username },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.username = $event.target.value
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "cloud-cont" },
                                [
                                  _c(
                                    "font",
                                    { staticClass: "cloud-cont-name" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "language.popup.addCloudPopup.passWord"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.password,
                                        expression: "password"
                                      }
                                    ],
                                    staticClass: "cloud-cont-input",
                                    style: {
                                      width:
                                        this.$i18n.locale == "italian"
                                          ? "450Px"
                                          : ""
                                    },
                                    attrs: { type: "password" },
                                    domProps: { value: _vm.password },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.password = $event.target.value
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.cloudName == "backblaze",
                                  expression: "cloudName == 'backblaze'"
                                }
                              ],
                              staticClass: "cloud-cont"
                            },
                            [
                              _c("font", { staticClass: "cloud-cont-name" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.addCloudPopup.bucketName"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.bucketName,
                                    expression: "bucketName"
                                  }
                                ],
                                staticClass: "cloud-cont-input",
                                class:
                                  _vm.cloudName == "amazonS3"
                                    ? "cloud-amazonS3-input"
                                    : "",
                                style: {
                                  width:
                                    this.$i18n.locale == "italian"
                                      ? "450Px"
                                      : ""
                                },
                                attrs: { type: "text" },
                                domProps: { value: _vm.bucketName },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.bucketName = $event.target.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.cloudName == "backblaze",
                                  expression: "cloudName == 'backblaze'"
                                }
                              ],
                              staticClass: "cloud-cont"
                            },
                            [
                              _c("font", { staticClass: "cloud-cont-name" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("language.popup.addCloudPopup.keyID")
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.keyID,
                                    expression: "keyID"
                                  }
                                ],
                                staticClass: "cloud-cont-input",
                                class:
                                  _vm.cloudName == "amazonS3"
                                    ? "cloud-amazonS3-input"
                                    : "",
                                style: {
                                  width:
                                    this.$i18n.locale == "italian"
                                      ? "450Px"
                                      : ""
                                },
                                attrs: { type: "text" },
                                domProps: { value: _vm.keyID },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.keyID = $event.target.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.cloudName == "backblaze",
                                  expression: "cloudName == 'backblaze'"
                                }
                              ],
                              staticClass: "cloud-cont"
                            },
                            [
                              _c("font", { staticClass: "cloud-cont-name" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.addCloudPopup.applicationKey"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.applicationKey,
                                    expression: "applicationKey"
                                  }
                                ],
                                staticClass: "cloud-cont-input",
                                class:
                                  _vm.cloudName == "amazonS3"
                                    ? "cloud-amazonS3-input"
                                    : "",
                                style: {
                                  width:
                                    this.$i18n.locale == "italian"
                                      ? "450Px"
                                      : ""
                                },
                                attrs: { type: "text" },
                                domProps: { value: _vm.applicationKey },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.applicationKey = $event.target.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.cloudName == "webDav" ||
                          _vm.cloudName == "ownCloud"
                            ? _c(
                                "div",
                                { staticClass: "cloud-cont" },
                                [
                                  _c(
                                    "font",
                                    { staticClass: "cloud-cont-name" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "language.popup.addCloudPopup.path"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.cloudName == "webDav"
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.path,
                                            expression: "path"
                                          }
                                        ],
                                        staticClass: "cloud-cont-input",
                                        style: {
                                          width:
                                            this.$i18n.locale == "italian"
                                              ? "450Px"
                                              : ""
                                        },
                                        attrs: { type: "text" },
                                        domProps: { value: _vm.path },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.path = $event.target.value
                                          }
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.cloudName == "ownCloud"
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.ownCloudpath,
                                            expression: "ownCloudpath"
                                          }
                                        ],
                                        staticClass: "cloud-cont-input",
                                        style: {
                                          width:
                                            this.$i18n.locale == "italian"
                                              ? "450Px"
                                              : ""
                                        },
                                        attrs: { type: "text" },
                                        domProps: { value: _vm.ownCloudpath },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.ownCloudpath =
                                              $event.target.value
                                          }
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.cloudName == "gSuite",
                                  expression: "cloudName == 'gSuite'"
                                }
                              ],
                              staticClass: "add-cloud-info",
                              attrs: { id: "containerUp" }
                            },
                            [
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t(
                                      "language.popup.addCloudPopup.gSuiteUpTips"
                                    )
                                  )
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.unTips.includes(_vm.cloudName),
                                  expression: "!unTips.includes(cloudName)"
                                }
                              ]
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: { cursor: "pointer" },
                                  on: {
                                    click: function($event) {
                                      _vm.tipShow = !_vm.tipShow
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "add-cloud-tips" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("language.popup.tips"))
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass:
                                      "icon-util folding-panel slide",
                                    class: _vm.tipShow
                                      ? "folding-panel-up"
                                      : "folding-panel-down"
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "add-drive-footer" },
                                [
                                  _c(
                                    "transition",
                                    { attrs: { name: "tip-slide" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.tipShow,
                                              expression: "tipShow"
                                            }
                                          ],
                                          ref: "container",
                                          staticClass: "add-cloud-info",
                                          attrs: { id: "container" }
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("getStrValue")(
                                                  _vm.$t(
                                                    "language.popup.addCloudPopup." +
                                                      _vm.cloudName +
                                                      "Tips"
                                                  )
                                                )
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.cloudName == "wasabi",
                                  expression: "cloudName == 'wasabi'"
                                }
                              ],
                              staticClass: "cloud-cont"
                            },
                            [
                              _c("font", { staticClass: "cloud-cont-name" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.addCloudPopup.accessKeyId"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.wasabiAccessKey,
                                    expression: "wasabiAccessKey"
                                  }
                                ],
                                staticClass: "cloud-cont-input",
                                style: {
                                  width:
                                    this.$i18n.locale == "italian" ||
                                    this.$i18n.locale == "nederlands"
                                      ? "450Px"
                                      : ""
                                },
                                attrs: { type: "text" },
                                domProps: { value: _vm.wasabiAccessKey },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.wasabiAccessKey = $event.target.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.cloudName == "wasabi",
                                  expression: "cloudName == 'wasabi'"
                                }
                              ],
                              staticClass: "cloud-cont"
                            },
                            [
                              _c("font", { staticClass: "cloud-cont-name" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.addCloudPopup.secretAccessKey"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.wasabiSecretAccessPassword,
                                    expression: "wasabiSecretAccessPassword"
                                  }
                                ],
                                staticClass: "cloud-cont-input",
                                style: {
                                  width:
                                    this.$i18n.locale == "italian" ||
                                    this.$i18n.locale == "nederlands"
                                      ? "450Px"
                                      : ""
                                },
                                attrs: { type: "passWord" },
                                domProps: {
                                  value: _vm.wasabiSecretAccessPassword
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.wasabiSecretAccessPassword =
                                      $event.target.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.cloudName == "iCloudPhotos",
                                  expression: "cloudName == 'iCloudPhotos'"
                                }
                              ]
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "cloud-cont" },
                                [
                                  _c(
                                    "font",
                                    { staticClass: "cloud-cont-name" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("language.popup.domain"))
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.domain,
                                        expression: "domain"
                                      }
                                    ],
                                    staticClass: "cloud-cont-input",
                                    style: {
                                      width:
                                        this.$i18n.locale == "italian"
                                          ? "450Px"
                                          : ""
                                    },
                                    attrs: { type: "text" },
                                    domProps: { value: _vm.domain },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.domain = $event.target.value
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "cloud-cont" },
                                [
                                  _c(
                                    "font",
                                    { staticClass: "cloud-cont-name" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "language.popup.addCloudPopup.appleId"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.appleId,
                                        expression: "appleId"
                                      }
                                    ],
                                    staticClass: "cloud-cont-input",
                                    style: {
                                      width:
                                        this.$i18n.locale == "italian"
                                          ? "450Px"
                                          : ""
                                    },
                                    attrs: { type: "text" },
                                    domProps: { value: _vm.appleId },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.appleId = $event.target.value
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "cloud-cont" },
                                [
                                  _c(
                                    "font",
                                    { staticClass: "cloud-cont-name" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "language.popup.addCloudPopup.passWord"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.password,
                                        expression: "password"
                                      }
                                    ],
                                    staticClass: "cloud-cont-input",
                                    style: {
                                      width:
                                        this.$i18n.locale == "italian"
                                          ? "450Px"
                                          : ""
                                    },
                                    attrs: { type: "password" },
                                    domProps: { value: _vm.password },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.password = $event.target.value
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "add-drive-submit",
                                  on: { click: _vm.addDrive }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.connect,
                                          expression: "!connect"
                                        }
                                      ]
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "language.popup.addCloudPopup.addICloudPhotos"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.connect,
                                          expression: "connect"
                                        }
                                      ]
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.$t("language.common.connecting")
                                          ) +
                                          "\n                                "
                                      ),
                                      _c("span", {
                                        staticClass: "cloudDotting"
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.cloudName == "iCloudDrive",
                                  expression: "cloudName == 'iCloudDrive'"
                                }
                              ]
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "cloud-cont" },
                                [
                                  _c(
                                    "font",
                                    { staticClass: "cloud-cont-name" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("language.popup.domain"))
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.domain,
                                        expression: "domain"
                                      }
                                    ],
                                    staticClass: "cloud-cont-input",
                                    style: {
                                      width:
                                        this.$i18n.locale == "italian"
                                          ? "450Px"
                                          : ""
                                    },
                                    attrs: { type: "text" },
                                    domProps: { value: _vm.domain },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.domain = $event.target.value
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "cloud-cont" },
                                [
                                  _c(
                                    "font",
                                    { staticClass: "cloud-cont-name" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "language.popup.addCloudPopup.appleId"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.appleId,
                                        expression: "appleId"
                                      }
                                    ],
                                    staticClass: "cloud-cont-input",
                                    style: {
                                      width:
                                        this.$i18n.locale == "italian"
                                          ? "450Px"
                                          : ""
                                    },
                                    attrs: { type: "text" },
                                    domProps: { value: _vm.appleId },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.appleId = $event.target.value
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "cloud-cont" },
                                [
                                  _c(
                                    "font",
                                    { staticClass: "cloud-cont-name" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "language.popup.addCloudPopup.passWord"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.password,
                                        expression: "password"
                                      }
                                    ],
                                    staticClass: "cloud-cont-input",
                                    style: {
                                      width:
                                        this.$i18n.locale == "italian"
                                          ? "450Px"
                                          : ""
                                    },
                                    attrs: { type: "password" },
                                    domProps: { value: _vm.password },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.password = $event.target.value
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "add-drive-submit",
                                  on: { click: _vm.addDrive }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.connect,
                                          expression: "!connect"
                                        }
                                      ]
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "language.popup.addCloudPopup.addICloudDrive"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.connect,
                                          expression: "connect"
                                        }
                                      ]
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.$t("language.common.connecting")
                                          ) +
                                          "\n                                "
                                      ),
                                      _c("span", {
                                        staticClass: "cloudDotting"
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  ]
                )
              : _vm._e()
          ]),
      _vm._v(" "),
      _c("checkAppleDialog", { ref: "checkAppleDialog" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e18e677", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e18e677","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/add_cloud_popups/add_cloud_popup.vue
// module id = null
// module chunks = 